export const SET_CUSTOMER_CONTACTS_EMAILS = 'SET_CUSTOMER_CONTACTS_EMAILS';
export const SET_IS_SHOW_CORRESPODENCE = 'SET_IS_SHOW_CORRESPODENCE';
export const SET_CUSTOMER_DETAILS_IS_OPEN = 'SET_CUSTOMER_DETAILS_IS_OPEN';